import {
  ROLE_MGS_ABRECHNUNG,
  ROLE_MGS_ADMIN,
  ROLE_MGS_ARZT,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_FALLDATEN,
  ROLE_MGS_REZEPTION,
  ROLE_MGS_SPOWI,
  ROLE_MGS_SUPER_ADMIN,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from './mgs-roles';

export function hasRole(role: string, roles: string[]): boolean {
  return roles?.some((current) => current === role);
}

export function hasAnyRole(searchRoles: string[], roles: string[]): boolean {
  return searchRoles?.some((role) => hasRole(role, roles));
}

export function isMgsAdmin(roles: string[]): boolean {
  return hasRole(ROLE_MGS_ADMIN, roles);
}

export function isMgsFalldatenUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_FALLDATEN, roles);
}

export function isMgsBuchungszentraleUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_BUCHUNG, roles);
}

export function isMgsSpowiUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_SPOWI, roles);
}

export function isMgsAbrechnungUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_ABRECHNUNG, roles);
}

export function isMgsRezeptionUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_REZEPTION, roles);
}

export function isMgsSuperAdmin(roles: string[]): boolean {
  return hasRole(ROLE_MGS_SUPER_ADMIN, roles);
}

export function isMgsArzt(roles: string[]): boolean {
  return hasRole(ROLE_MGS_ARZT, roles);
}

export function isMgsKidsTerminUser(roles: string[]): boolean {
  return hasRole(ROLE_MGS_USER_FOR_KIDS_TERMIN, roles);
}
